import React from 'react';
import { useField } from 'formik';
import { TextField } from '@mui/material';

interface ValidatedInputFieldsProps {
  name: string;
  label: string;
  textFieldType: string;
  fullWidth?: boolean;
}

const InputField = (props: ValidatedInputFieldsProps) => {
  const { name, label, fullWidth, textFieldType } = props;
  const [field, meta] = useField(props);
  const { onBlur, onChange, value } = field;

  function renderHelperText() {
    if (meta.touched && meta.error) {
      return meta.error;
    }
    return null;
  }

  return (
    <TextField
      type={textFieldType}
      error={(meta.touched && meta.error && true) as boolean}
      helperText={renderHelperText()}
      autoComplete="new-password"
      {...{ name, onBlur, onChange, value, label, fullWidth }}
    />
  );
};
export default InputField;
